import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { collection, onSnapshot } from "firebase/firestore";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import { db } from "../../firebase/firebase";
import LeftMessgeSection from "../common/LeftMessgeSection";
import RightMessageSection from "../common/RightMessageSection";

const ChatMessageViewModal = ({
  isOpen,
  onClose,
  bookingId,
  consumerId,
  provider,
}) => {
  const navigate = useNavigate();

  const [chatMessages, setChatMessages] = useState([]);
  const [chatLoading, setChatLoading] = useState(false);
  let lastDisplayedDate = null;

  useEffect(() => {
    if ((!bookingId || typeof bookingId !== "string") && !isOpen) {
      return;
    }

    const chatRef = collection(db, "chat", bookingId, "chats");
    setChatLoading(true);

    // Subscribe to real-time updates
    const unsubscribe = onSnapshot(
      chatRef,
      (snapshot) => {
        try {
          if (!snapshot.empty) {
            const chatArray = snapshot?.docs?.map((doc) => ({
              id: doc?.id,
              ...doc?.data(),
            }));
            setChatMessages(chatArray);
            setChatLoading(false);
          } else {
            setChatMessages([]); // Set empty array if no chats found
            setChatLoading(false);
          }
        } catch (err) {
          setChatLoading(false);
          console.log("Error fetching chat data:", err);
          toast.error("Failed to fetch chat messages.");
        }
      },
      (error) => {
        setChatLoading(false);
        toast.error("An error occurred while fetching chat data.");
        console.log("Firestore snapshot error:", error);
      }
    );

    // Cleanup the listener on unmount
    return () => unsubscribe();
  }, [bookingId, isOpen]);

  return (
    <>
      <Dialog open={isOpen} onClose={onClose} className="relative z-50">
        <DialogBackdrop className="fixed inset-0 bg-gray-500/75 transition-opacity" />
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel className="relative w-full transform overflow-hidden bg-white text-left shadow-xl transition-all rounded-lg sm:max-w-md md:max-w-lg">
              <div className="bg-[#21140E0F] px-4 pb-6 pt-3 sm:px-6">
                <div className="flex justify-between items-center mb-4">
                  <DialogTitle className="text-lg sm:text-xl font-bold text-[#284184]">
                    View Message
                  </DialogTitle>
                  <button
                    onClick={onClose}
                    className="text-[#1C2024] p-1.5 rounded-full"
                  >
                    <IoMdClose className="text-xl sm:text-2xl" />
                  </button>
                </div>
                <div className="bg-[#fff] w-full rounded-lg shadow-md ">
                  <div className="grid grid-cols-3 p-4 border-b-2">
                    <div className=" col-span-2">
                      <p className="text-end me-12 text-[#284184] text-lg font-semibold">
                        {provider?.provider_name}
                      </p>
                    </div>
                    <button
                      className="text-[#E0A256] text-base flex items-center justify-end space-x-1"
                      onClick={() =>
                        navigate("/providerProfile", {
                          state: { provider: { id: provider?.provider_id } },
                        })
                      }
                    >
                      <span className="underline">View Provider</span>
                    </button>
                  </div>
                  <div className="p-4 max-h-[450px] overflow-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300">
                    {chatLoading ? (
                      <div className="flex justify-center items-center h-[25vh]">
                        <PropagateLoader color="#284184" loading={true} />
                      </div>
                    ) : chatMessages?.length === 0 ? (
                      <>
                        <p className="text-md font-semibold text-center flex items-center justify-center h-[25vh]">
                          No Chat Found!!!
                        </p>
                      </>
                    ) : (
                      chatMessages &&
                      chatMessages?.length !== 0 &&
                      chatMessages?.map((msg, index) => {
                        const messageDate = moment(msg.dateTime).format(
                          "YYYY-MM-DD"
                        );
                        const isToday = moment(msg.dateTime).isSame(
                          moment(),
                          "day"
                        );
                        const formattedTime = moment(msg.dateTime).format(
                          "hh:mm A"
                        );

                        const showDateHeader =
                          lastDisplayedDate !== messageDate;
                        lastDisplayedDate = messageDate;
                        return (
                          <React.Fragment key={index}>
                            {showDateHeader && (
                              <div className="flex justify-center items-center mb-2">
                                <p className="bg-[#FFEED0] text-[#E0A256] font-semibold text-sm py-1 px-3 rounded-md">
                                  {isToday
                                    ? "Today"
                                    : moment(msg.dateTime).format(
                                        "MMM D, YYYY"
                                      )}
                                </p>
                              </div>
                            )}

                            {msg?.senderId === consumerId ? (
                              <LeftMessgeSection
                                text={msg?.msg}
                                time={formattedTime}
                                isSeen={msg?.isSeen}
                              />
                            ) : (
                              <RightMessageSection
                                text={msg?.msg}
                                time={formattedTime}
                                isSeen={msg?.isSeen}
                              />
                            )}
                          </React.Fragment>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default ChatMessageViewModal;
